/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/pickuppointfee/list/pickup-point-fee-list.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../../public/upgrade/feature/pickuppointfee/pickup-point-fee.service';
import * as import6 from '../../../../../../public/upgrade/core/point-of-sale.service.service';
import * as import7 from '../../../../../../public/upgrade/core/additional-pickup-point.service';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/change_detection/constants';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '@angular/http/src/http';
import * as import12 from '@ngx-translate/core/src/translate.service';
import * as import13 from '../../../../../../public/upgrade/root/modal/modal.service';
import * as import14 from '../../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import15 from '@angular/router/src/router';
import * as import16 from '@angular/router/src/router_state';
import * as import17 from '../../../../../../public/upgrade/core/session.service';
import * as import18 from '@angular/core/src/zone/ng_zone';
import * as import19 from '../../../../../../public/upgrade/root/sidebar/sidebar.service';
import * as import20 from '../../../../../../public/upgrade/shared/list-card/list-card.component';
import * as import21 from '../../../shared/list-card/list-card.component.ngfactory';
import * as import22 from '../../../../../../public/upgrade/feature/pickuppointfee/list/fee-card-content/pickup-point-fee-card-content.component';
import * as import23 from './fee-card-content/pickup-point-fee-card-content.component.ngfactory';
import * as import24 from '@angular/core/src/linker/view_container';
import * as import25 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import26 from '@angular/core/src/linker/template_ref';
import * as import27 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import28 from '@angular/common/src/directives/ng_for';
import * as import29 from '../../../../../../public/upgrade/shared/eva-button/eva-button.component';
import * as import30 from '../../../shared/eva-button/eva-button.component.ngfactory';
import * as import31 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import32 from '../../../../../../public/upgrade/shared/pager/eva-pager.component';
import * as import33 from '../../../shared/pager/eva-pager.component.ngfactory';
import * as import34 from '@ngx-translate/core/src/translate.pipe';
import * as import35 from '@angular/core/src/change_detection/change_detection_util';
import * as import36 from '@angular/common/src/directives/ng_if';
export class Wrapper_PickupPointFeeListComponent {
  /*private*/ _eventHandler:Function;
  context:import0.PickupPointFeeListComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any) {
    this._changed = false;
    this.context = new import0.PickupPointFeeListComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_PickupPointFeeListComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_PickupPointFeeListComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.PickupPointFeeListComponent>;
  _PickupPointFeeService_0_3:import5.PickupPointFeeService;
  _PointOfSaleA2Service_0_4:import6.PointOfSaleA2Service;
  _AdditionalPickupPointService_0_5:import7.AdditionalPickupPointService;
  _PickupPointFeeListComponent_0_6:Wrapper_PickupPointFeeListComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PickupPointFeeListComponent_Host0,renderType_PickupPointFeeListComponent_Host,import8.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'pickup-point-fee-list',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_PickupPointFeeListComponent0(this.viewUtils,this,0,this._el_0);
    this._PickupPointFeeService_0_3 = new import5.PickupPointFeeService(this.injectorGet(import11.Http,this.parentIndex),this.injectorGet(import12.TranslateService,this.parentIndex));
    this._PointOfSaleA2Service_0_4 = new import6.PointOfSaleA2Service(this.injectorGet(import11.Http,this.parentIndex));
    this._AdditionalPickupPointService_0_5 = new import7.AdditionalPickupPointService(this.injectorGet(import11.Http,this.parentIndex));
    this._PickupPointFeeListComponent_0_6 = new Wrapper_PickupPointFeeListComponent(this.injectorGet(import13.ModalService,this.parentIndex),this.injectorGet(import14.LoadingWheelService,this.parentIndex),this._PickupPointFeeService_0_3,this.injectorGet(import15.Router,this.parentIndex),this.injectorGet(import16.ActivatedRoute,this.parentIndex),this._PointOfSaleA2Service_0_4,this.injectorGet(import17.SessionService,this.parentIndex),this._AdditionalPickupPointService_0_5,this.injectorGet(import18.NgZone,this.parentIndex),this.injectorGet(import19.SidebarService,this.parentIndex));
    this.compView_0.create(this._PickupPointFeeListComponent_0_6.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import10.ComponentRef_<any>(0,this,this._el_0,this._PickupPointFeeListComponent_0_6.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.PickupPointFeeService) && (0 === requestNodeIndex))) { return this._PickupPointFeeService_0_3; }
    if (((token === import6.PointOfSaleA2Service) && (0 === requestNodeIndex))) { return this._PointOfSaleA2Service_0_4; }
    if (((token === import7.AdditionalPickupPointService) && (0 === requestNodeIndex))) { return this._AdditionalPickupPointService_0_5; }
    if (((token === import0.PickupPointFeeListComponent) && (0 === requestNodeIndex))) { return this._PickupPointFeeListComponent_0_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._PickupPointFeeListComponent_0_6.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const PickupPointFeeListComponentNgFactory:import10.ComponentFactory<import0.PickupPointFeeListComponent> = new import10.ComponentFactory<import0.PickupPointFeeListComponent>('pickup-point-fee-list',View_PickupPointFeeListComponent_Host0,import0.PickupPointFeeListComponent);
const styles_PickupPointFeeListComponent:any[] = ([] as any[]);
class View_PickupPointFeeListComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import20.ListCardComponent>;
  _ListCardComponent_2_3:import21.Wrapper_ListCardComponent;
  _text_3:any;
  _el_4:any;
  compView_4:import1.AppView<import22.PickupPointFeeCardContentComponent>;
  _PickupPointFeeCardContentComponent_4_3:import23.Wrapper_PickupPointFeeCardContentComponent;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _map_12:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import24.ViewContainer) {
    super(View_PickupPointFeeListComponent2,renderType_PickupPointFeeListComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_12 = import3.pureProxy3((p0:any,p1:any,p2:any):{[key: string]:any} => {
      return {
        title: p0,
        editable: p1,
        removable: p2
      }
      ;
    });
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'list-card',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import21.View_ListCardComponent0(this.viewUtils,this,2,this._el_2);
    this._ListCardComponent_2_3 = new import21.Wrapper_ListCardComponent(this.compView_2.ref);
    this._text_3 = this.renderer.createText((null as any),'\n                                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,(null as any),'pickup-point-fee-card-content',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import23.View_PickupPointFeeCardContentComponent0(this.viewUtils,this,4,this._el_4);
    this._PickupPointFeeCardContentComponent_4_3 = new import23.Wrapper_PickupPointFeeCardContentComponent(this.parentView.parentView.parentView.injectorGet(import17.SessionService,this.parentView.parentView.parentIndex));
    this._text_5 = this.renderer.createText((null as any),'\n                                        ',(null as any));
    this.compView_4.create(this._PickupPointFeeCardContentComponent_4_3.context);
    this._text_6 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_2.create(this._ListCardComponent_2_3.context);
    this._text_7 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'edit',(null as any),'remove',(null as any)),this.eventHandler(this.handleEvent_2));
    this._ListCardComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true,true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.PickupPointFeeCardContentComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 5)))) { return this._PickupPointFeeCardContentComponent_4_3.context; }
    if (((token === import20.ListCardComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 6)))) { return this._ListCardComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this._map_12((!!this.context.$implicit.identifier? this.context.$implicit.identifier.name: this.context.$implicit.name),((this.context.$implicit.oid != 0) && this.parentView.parentView.context.isEditable()),((this.context.$implicit.oid != 0) && this.parentView.parentView.context.isRemovable()));
    this._ListCardComponent_2_3.check_listCard(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = 110;
    this._ListCardComponent_2_3.check_cardHeight(currVal_2_0_1,throwOnChange,false);
    this._ListCardComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_4_0_0:any = this.context.$implicit;
    this._PickupPointFeeCardContentComponent_4_3.check_model(currVal_4_0_0,throwOnChange,false);
    const currVal_4_0_1:any = this.parentView.parentView.context.pickupsMap;
    this._PickupPointFeeCardContentComponent_4_3.check_pupMap(currVal_4_0_1,throwOnChange,false);
    this._PickupPointFeeCardContentComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { this._ListCardComponent_2_3.context.ngAfterViewChecked(); }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this.compView_4.destroy();
    this._ListCardComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  visitProjectableNodesInternal(nodeIndex:number,ngContentIndex:number,cb:any,ctx:any):void {
    if (((nodeIndex == 2) && (ngContentIndex == 0))) {
      cb(this._text_3,ctx);
      cb(this._el_4,ctx);
      cb(this._text_6,ctx);
    }
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'edit')) {
      const pd_sub_0:any = ((<any>this.parentView.parentView.context.edit(this.context.$implicit.oid)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'remove')) {
      const pd_sub_1:any = ((<any>this.parentView.parentView.context.remove(this.context.$implicit.oid)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_PickupPointFeeListComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import24.ViewContainer;
  _TemplateRef_2_5:any;
  _NgFor_2_6:import25.Wrapper_NgFor;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import24.ViewContainer) {
    super(View_PickupPointFeeListComponent1,renderType_PickupPointFeeListComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import24.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import26.TemplateRef_(this,2,this._anchor_2);
    this._NgFor_2_6 = new import25.Wrapper_NgFor(this._vc_2.vcRef,this._TemplateRef_2_5,this.parentView.parentView.injectorGet(import27.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_3 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import28.NgFor) && (2 === requestNodeIndex))) { return this._NgFor_2_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.page.pageItems;
    this._NgFor_2_6.check_ngForOf(currVal_2_0_0,throwOnChange,false);
    this._NgFor_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 2)) { return new View_PickupPointFeeListComponent2(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
}
var renderType_PickupPointFeeListComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_PickupPointFeeListComponent,{});
export class View_PickupPointFeeListComponent0 extends import1.AppView<import0.PickupPointFeeListComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  compView_25:import1.AppView<import29.EvaButtonComponent>;
  _EvaButtonComponent_25_3:import30.Wrapper_EvaButtonComponent;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _el_29:any;
  _text_30:any;
  _anchor_31:any;
  /*private*/ _vc_31:import24.ViewContainer;
  _TemplateRef_31_5:any;
  _NgIf_31_6:import31.Wrapper_NgIf;
  _text_32:any;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  compView_38:import1.AppView<import32.EvaPagerComponent>;
  _EvaPagerComponent_38_3:import33.Wrapper_EvaPagerComponent;
  _text_39:any;
  _text_40:any;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  /*private*/ _expr_51:any;
  _pipe_translate_0:import34.TranslatePipe;
  /*private*/ _expr_53:any;
  _pipe_translate_1:import34.TranslatePipe;
  /*private*/ _expr_55:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PickupPointFeeListComponent0,renderType_PickupPointFeeListComponent,import8.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
    this._expr_51 = import35.UNINITIALIZED;
    this._expr_53 = import35.UNINITIALIZED;
    this._expr_55 = import35.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-grid'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-row -m-top-lg'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-md-12 -sm-12'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'span',new import3.InlineArray2(2,'class','-h2 -eva-3-ml-xsm'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_12,'\n                            ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_12,'p',new import3.InlineArray4(4,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm -eva-3-ml-xsm','style','line-height: 16px;'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_12,'\n                        ',(null as any));
    this._text_20 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pb-sm -eva-3-pl-md -eva-3-fl'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n                            ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'div',new import3.InlineArray2(2,'class','eva-row -m-top-lg'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n                                ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_23,'eva-button',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_25 = new import30.View_EvaButtonComponent0(this.viewUtils,this,25,this._el_25);
    this._EvaButtonComponent_25_3 = new import30.Wrapper_EvaButtonComponent();
    this.compView_25.create(this._EvaButtonComponent_25_3.context);
    this._text_26 = this.renderer.createText(this._el_23,'\n                            ',(null as any));
    this._text_27 = this.renderer.createText(this._el_21,'\n                        ',(null as any));
    this._text_28 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-row -m-top-lg'),(null as any));
    this._text_30 = this.renderer.createText(this._el_29,'\n                            ',(null as any));
    this._anchor_31 = this.renderer.createTemplateAnchor(this._el_29,(null as any));
    this._vc_31 = new import24.ViewContainer(31,29,this,this._anchor_31);
    this._TemplateRef_31_5 = new import26.TemplateRef_(this,31,this._anchor_31);
    this._NgIf_31_6 = new import31.Wrapper_NgIf(this._vc_31.vcRef,this._TemplateRef_31_5);
    this._text_32 = this.renderer.createText(this._el_29,'\n                        ',(null as any));
    this._text_33 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_34 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_35 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-row -m-top-lg'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n                    ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_36,'eva-pager',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_38 = new import33.View_EvaPagerComponent0(this.viewUtils,this,38,this._el_38);
    this._EvaPagerComponent_38_3 = new import33.Wrapper_EvaPagerComponent();
    this.compView_38.create(this._EvaPagerComponent_38_3.context);
    this._text_39 = this.renderer.createText(this._el_36,'\n                ',(null as any));
    this._text_40 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_41 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_42 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_43 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import34.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import34.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_25,new import3.InlineArray2(2,'action',(null as any)),this.eventHandler(this.handleEvent_25));
    this._EvaButtonComponent_25_3.subscribe(this,this.eventHandler(this.handleEvent_25),true);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._anchor_31,
      this._text_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._text_40,
      this._text_41,
      this._text_42,
      this._text_43
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.EvaButtonComponent) && (25 === requestNodeIndex))) { return this._EvaButtonComponent_25_3.context; }
    if (((token === import26.TemplateRef) && (31 === requestNodeIndex))) { return this._TemplateRef_31_5; }
    if (((token === import36.NgIf) && (31 === requestNodeIndex))) { return this._NgIf_31_6.context; }
    if (((token === import32.EvaPagerComponent) && (38 === requestNodeIndex))) { return this._EvaPagerComponent_38_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import35.ValueUnwrapper();
    const currVal_25_0_0:any = this.context.newButton;
    this._EvaButtonComponent_25_3.check_button(currVal_25_0_0,throwOnChange,false);
    this._EvaButtonComponent_25_3.ngDoCheck(this,this._el_25,throwOnChange);
    const currVal_31_0_0:boolean = (!!((this.context.page == null)? (null as any): this.context.page.pageItems) && !!this.context.pickupsMap);
    this._NgIf_31_6.check_ngIf(currVal_31_0_0,throwOnChange,false);
    this._NgIf_31_6.ngDoCheck(this,this._anchor_31,throwOnChange);
    const currVal_38_0_0:any = this.context.page;
    this._EvaPagerComponent_38_3.check_config(currVal_38_0_0,throwOnChange,false);
    this._EvaPagerComponent_38_3.ngDoCheck(this,this._el_38,throwOnChange);
    this._vc_31.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_51:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('fees.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_51,currVal_51))) {
      this.renderer.setText(this._text_15,currVal_51);
      this._expr_51 = currVal_51;
    }
    valUnwrapper.reset();
    const currVal_53:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('fees.SUBTITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_53,currVal_53))) {
      this.renderer.setText(this._text_18,currVal_53);
      this._expr_53 = currVal_53;
    }
    const currVal_55:boolean = !this.context.canCreate();
    if (import3.checkBinding(throwOnChange,this._expr_55,currVal_55)) {
      this.renderer.setElementProperty(this._el_23,'hidden',currVal_55);
      this._expr_55 = currVal_55;
    }
    this.compView_25.internalDetectChanges(throwOnChange);
    this.compView_38.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_31.destroyNestedViews();
    this.compView_25.destroy();
    this.compView_38.destroy();
    this._EvaButtonComponent_25_3.ngOnDestroy();
    this._EvaPagerComponent_38_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 31)) { return new View_PickupPointFeeListComponent1(this.viewUtils,this,31,this._anchor_31,this._vc_31); }
    return (null as any);
  }
  handleEvent_25(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'action')) {
      const pd_sub_0:any = ((<any>this.context.add()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pickuppointfee/list/pickup-point-fee-list.component.ngfactory.ts